import { render } from "./vfeedbackopinion.vue?vue&type=template&id=44d04e69&scoped=true"
import script from "./vfeedbackopinion.vue?vue&type=script&lang=js"
export * from "./vfeedbackopinion.vue?vue&type=script&lang=js"

import "./vfeedbackopinion.vue?vue&type=style&index=0&id=44d04e69&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d04e69"]])

export default __exports__